export const suitesImages = [
    require("../../assets/Suites/SuitesSlider1.jpg"),
    require("../../assets/Suites/SuitesSlider2.jpg"),
    require("../../assets/Suites/SuitesSlider3.jpg"),
   ]